// TODO (alex): use for styling callout container
export const calloutHeight = 130
export const calloutWidth = 350

// Margin between callout and map area edges.
export const calloutMapMargin = 10

// TODO (alex): add marker types and have these values provided by each type
// Margin between callout and marker.
export const calloutMarkerMargin = 0
export const markerPositionOffset = -57

// Margin between bounds of map area and bounds containing all markers.
export const boundsMargin = 15

// Generated by https://mapstyle.withgoogle.com/
export const googleMapStyles = [
  {
    elementType: 'labels.text',
    featureType: 'poi',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'poi.business',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    elementType: 'labels.icon',
    featureType: 'road',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'transit',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
]
